import { RootState } from 'store/core'

export const getEntities =
  <T>(reducerName: keyof RootState) =>
  (state: RootState) => {
    const reducerState = state[reducerName]
    if ('entities' in reducerState) return reducerState.entities as unknown as Array<T>
    throw new Error(`entities key is not available in the ${reducerName} reducer`)
  }
